<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="予約状況照会（一覧）" />
            <template>
                <v-form ref="form" lazy-validation>
                    <v-row no-gutters class="mx-3">
                        <div class="column-width"><v-text-field
                            class="mr-3 pt-4"
                            label="予約番号"
                            maxlength="12"
                            v-model="reserveNo"
                        /></div>
                        <!--
                        # 注意事項

                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                        例）2021と入力すると、2021-20-21と入ってしまう。

                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                        （date を指定するとカレンダーが表示されてしまう）
                        -->
                        <div class="date-width"><v-menu
                            ref="menu"
                            v-model="reserveMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mr-3 pt-4"
                                    label="予約日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-on="on"
                                    v-model="formatedReserveDate"
                                    @focus="focusDate(applicationDate)"
                                    @keyup.delete="deleteKeyUpApplicationDate($event)"
                                    @keyup="applicationDate = formatDate(applicationDate)"
                                    @keydown.tab.exact="reserveMenu = false"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.correct_date]"
                                />
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="applicationDate"
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                min="1900-01-01"
                                @input="reserveMenu = false"
                            />
                        </v-menu></div>
                        <!-- <div><v-select
                            class="mr-3 pt-4"
                            label="予約状況"
                            :items="reserveSituationData"
                            item-value="code"
                            item-text="code_name"
                            v-model="reserveSituation"
                        /></div> -->
                        <div class="golf-width"><v-select
                            class="mr-3 pt-4"
                            :items="golfSelect"
                            item-value="golf_code"
                            item-text="golf_name"
                            v-model="golfCode"
                            label="ゴルフ場名"
                        ></v-select></div>
                        <div class="column-width"><v-text-field
                            class="mr-3 pt-4"
                            label="会員No"
                            v-model="memberNo"
                        /></div>
                        <div class="column-width"><v-text-field
                            class="mr-3 pt-4"
                            label="代表者（姓）"
                            v-model="familyName"
                        /></div>
                        <div class="column-width"><v-text-field
                            class="mr-3 pt-4"
                            label="代表者（名）"
                            v-model="givenName"
                        /></div>
                        <!--
                        # 注意事項

                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                        例）2021と入力すると、2021-20-21と入ってしまう。

                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                        （date を指定するとカレンダーが表示されてしまう）
                        -->
                        <div class="date-width"><v-menu
                            ref="menu"
                            v-model="playMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mr-3 pt-4"
                                    label="プレー日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-on="on"
                                    v-model="formatedPlayDate"
                                    @focus="focusDate(playDate)"
                                    @keyup.delete="deleteKeyUpPlayDate($event)"
                                    @keyup="playDate = formatDate(playDate)"
                                    @keydown.tab.exact="playMenu = false"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.correct_date]"
                                />
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="playDate"
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                min="1900-01-01"
                                @input="playMenu = false"
                            />
                        </v-menu></div>
                        <!-- <v-checkbox
                            class="mr-3 selectWidth"
                            v-model="normal"
                            label="通常予約"
                        />
                        <v-checkbox
                            class="mr-3 selectWidth"
                            v-model="share"
                            label="シェア予約"
                        /> -->
                        <v-checkbox
                            class="mr-3 selectWidth"
                            v-model="completed"
                            label="未返信メッセージあり"
                        />
                        <v-btn
                            color="primary"
                            class="ml-5 mt-3"
                            v-on:click="checkValidateSearch"
                            :disabled="btn[1].isActive"
                        >検索</v-btn>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-form>
            </template>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <div class="ml-6 reserve-title">予約一覧</div>
                <v-spacer></v-spacer>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="desserts"
                hide-default-footer
                class="elevation-1"
                fixed-header
            >
                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        v-if="item.reserve_no"
                        @click="openModal(item)"
                        :disabled="btn[2].isActive"
                        >詳細</v-btn>
                </template>
                <template v-slot:[`item.companion`]="{ item }">
                    <div v-if="item.reserve_situation==4" class="isCancell">登録</div>
                    <v-btn
                        text
                        color="primary"
                        v-else-if="item.reserve_no"
                        @click="openCompanionModal(item)"
                        :disabled="btn[3].isActive"
                        >登録</v-btn>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
                @input="clickPagination"
            ></v-pagination>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <div class="ml-6 reserve-title">キャンセル一覧</div>
                <v-spacer></v-spacer>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="cancelList"
                hide-default-footer
                class="elevation-1"
                fixed-header
            >
                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        v-if="item.reserve_no"
                        @click="openModal(item)"
                        :disabled="btn[2].isActive"
                        >詳細</v-btn>
                </template>
                <template v-slot:[`item.companion`]="{ item }">
                    <div v-if="item.reserve_situation==4" class="isCancell">登録</div>
                    <v-btn
                        text
                        color="primary"
                        v-else-if="item.reserve_no"
                        @click="openCompanionModal(item)"
                        :disabled="btn[3].isActive"
                        >登録</v-btn>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="cancelPage"
                :length="cancelPageCount"
                :total-visible="7"
                @input="clickPagination"
            ></v-pagination>

            <ReserveDetailModal
                ref="Modal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                :chatboxSetting="chatboxSetting"
                @refresh-event="getReserveList">
            </ReserveDetailModal>
            <RequestDetailModal
                ref="RequestModal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                :chatboxSetting="chatboxSetting"
                @refresh-event="getReserveList">
            </RequestDetailModal>
            <ChangeVisited
                ref="CompanionDialogView"
                @close-companion="closeCompanionModal"
            />

        </v-card>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
// モーダル
import ReserveDetailModal from './modal/ReserveDetail';
import RequestDetailModal from './modal/ReserveRequestDetail';
import ChangeVisited from './modal/ChangeVisited';

// mixin
import { utilityMixin } from '../../mixins/utility';

// graphql
import { GET_RESERVE_LIST_BY_CONDITION, GET_RESERVE_ALL_LIST_BY_CONDITION } from '@/constants/reserve';

export default {
    components: {
        CardTitle,
        ReserveDetailModal,
        RequestDetailModal,
        ChangeVisited
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            cancelPage: 1,
            cancelPageCount: 0,
            maxRows: 10,
            begin_row: 0,
            cancel_begin_row: 0,
            limit_rows: 10,
            reserveNo: '',
            applicationDate: '',
            reserveSituation: '',
            memberNo: '',
            familyName: '',
            givenName: '',
            playDate: '',
            golfCode: '',
            normal: false,
            share: false,
            completed: false,
            // データテーブルに渡す値
            desserts: [],
            cancelList: [],
            result: '',
            resultText: '',
            // データテーブルの見出し要素
            headers: [
                { text: 'プレー日', sortable: false, value: 'play_date' },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                { text: '予約種別', value: 'reserve_type_name', sortable: false },
                { text: '代表者', align: 'center', value: 'full_name', sortable: false },
                // { text: '予約状況', align: 'center', value: 'reserve_situation_name', sortable: false },
                { text: '枠数', align: 'center', value: 'cell_number', sortable: false },
                { text: '人数', align: 'center', value: 'play_number', sortable: false },
                { text: '詳細', align: 'center', value: 'detail', sortable: false },
                { text: '来場実績登録', align: 'center', value: 'companion', sortable: false }
            ],
            // 生年月日の日付格納用
            date: null,
            // データ格納用
            reserveSituationData: [],
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // モーダルウィンドウの状態
            dialog: false,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            // エラーメッセージ
            error: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '詳細', isActive: true },
                { element_id: '003', element_name: '登録', isActive: true }
            ],
            vue_id: 'SCR0015',
            // ゴルフ場セレクトボックス
            golfSelect: [],
            originalData: [],
            detailInfo: {
                reserve_no: '',
                dialog: true
            },
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            },
            reserveMenu: false,
            playMenu: false,
            chatboxSetting: false
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        // クラシックの場合
        if (process.env.VUE_APP_NAME === 'hcgc') {
            this.headers[1].text = 'スタート時間';
            this.headers[1].value = 'play_start';
        }
        this.initialize();
        this.$store.commit('loading/setIsLoading', false);
    },
    computed: {
        formatedReserveDate: {
            get () {
                return this.applicationDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.applicationDate = value;
            }
        },
        formatedPlayDate: {
            get () {
                return this.playDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.playDate = value;
            }
        }
    },
    methods: {
        /** --------------------------------------------
        * 初期表示
        * --------------------------------------------- */
        initialize () {
            this.$apollo.query({
                query: GET_RESERVE_ALL_LIST_BY_CONDITION,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    reserve_no: this.reserveNo,
                    application_date: this.applicationDate,
                    reserve_situation: this.reserveSituation,
                    member_no: this.memberNo,
                    family_name: this.familyName,
                    given_name: this.givenName,
                    play_date: this.playDate,
                    begin_row: this.begin_row,
                    cancel_begin_row: this.cancel_begin_row,
                    limit_rows: this.limit_rows,
                    normal: this.normal,
                    share: this.share,
                    message_completed: this.completed,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            })
                .then(res => {
                    // 管理者権限情報取得
                    this.admin = res.data.getReserveAllListByCondition.GetLoginAdmin;
                    // ゴルフ場リスト取得
                    this.golfSelect = res.data.getReserveAllListByCondition.GetGolfCourseList;
                    this.golfCode = this.golfSelect[0].golf_code;
                    // 予約状況
                    // this.reserveSituationData = res.data.getReserveAllListByCondition.CodeList;
                    // this.reserveSituationData.unshift({ code: '', code_name: '' });
                    // // ステータスが受付のものは削除
                    // this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '1');
                    // // ステータスが来場済みのものは削除 2020/12/18
                    // this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '3');
                    // 予約一覧取得
                    const count = res.data.getReserveAllListByCondition.count;
                    this.pageCount = Math.ceil(count / this.maxRows);
                    this.desserts = res.data.getReserveAllListByCondition.ReserveList;
                    this.cancelList = res.data.getReserveAllListByCondition.CancelReserveList;
                    const cancelCount = res.data.getReserveAllListByCondition.CancelCount;
                    this.cancelPageCount = Math.ceil(cancelCount / this.maxRows);

                    // 権限情報取得
                    let opeList = res.data.getReserveAllListByCondition.OperationAccessList;
                    for (let list of opeList) {
                        this.btn.forEach(el => {
                            if (list.element_id === el.element_id) {
                                if (list.element_control === 0) {
                                    el.isActive = true;
                                } else {
                                    el.isActive = false;
                                }
                            }
                        });
                    };
                });
        },
        /** --------------------------------------------
        * 予約一覧情報を取得
        * -------------------------------------------- */
        async getReserveList () {
            try {
                await this.$apollo
                    .query({
                        query: GET_RESERVE_LIST_BY_CONDITION,
                        fetchPolicy: 'no-cache',
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golfCode,
                            reserve_no: this.reserveNo,
                            application_date: this.applicationDate,
                            reserve_situation: this.reserveSituation,
                            member_no: this.memberNo,
                            family_name: this.familyName,
                            given_name: this.givenName,
                            play_date: this.playDate,
                            begin_row: this.begin_row,
                            cancel_begin_row: this.cancel_begin_row,
                            limit_rows: this.limit_rows,
                            normal: this.normal,
                            share: this.share,
                            message_completed: this.completed
                        }
                    })
                    .then(res => {
                        const count = res.data.getReserveListByCondition.count;
                        this.pageCount = Math.ceil(count / this.maxRows);
                        this.desserts = res.data.getReserveListByCondition.ReserveList;
                        this.cancelList = res.data.getReserveListByCondition.CancelReserveList;
                        const cancelCount = res.data.getReserveListByCondition.CancelCount;
                        this.cancelPageCount = Math.ceil(cancelCount / this.maxRows);
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 予約詳細を開く処理
         * ---------------------------------------------- */
        openModal: function (data) {
            this.detailInfo.reserve_no = data.reserve_no;
            this.detailInfo.member_no = data.member_no;
            if (data.reserve_type === 3) {
                this.$refs.RequestModal.openModal();
            } else {
                this.$refs.Modal.openModal();
            }
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        checkValidateSearch () {
            if (this.$refs.form.validate()) {
                this.clickSearch();
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        clickSearch: function () {
            this.page = 1;
            this.cancelPage = 1;
            this.begin_row = 0;
            this.cancel_begin_row = 0;
            this.getReserveList();
        },
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * this.maxRows - this.maxRows;
            this.cancel_begin_row = this.cancelPage * this.maxRows - this.maxRows;
            this.getReserveList();
        },
        /** ----------------------------------------------
         * 来場実績モーダルを開く処理
         * ---------------------------------------------- */
        openCompanionModal (data) {
            if (this.dialog) return;
            this.dialog = true;
            this.$refs.CompanionDialogView.OpenDialog(data.reserve_no, true);
        },
        /** ----------------------------------------------
         * 来場実績モーダルを閉じる処理
         * ---------------------------------------------- */
        closeCompanionModal () {
            this.dialog = false;
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpApplicationDate (event) {
            this.applicationDate = this.formatDate(this.applicationDate);
            this.applicationDate = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpPlayDate (event) {
            this.playDate = this.formatDate(this.playDate);
            this.playDate = this.deleteKeyDelete(event);
        }
    }
};
</script>

<style scoped>
.selectWidth {
    width: 200px;
}
.isCancell {
    color: #cccccc !important;
}
.date-width {
    width: 110px;
}
.column-width {
    width: 130px;
}
.golf-width {
    width: 300px;
}
.reserve-title {
    font-size: 24px;
}
.v-data-table ::v-deep td {
    word-break: break-word;
    padding: 0px 12px;
    font-size: .875rem;
    height: 35px;
}
</style>
